export default __webpack_public_path__ + "5c309ce649f552ec1d39fb3623b6f165.png";